module.exports = __webpack_public_path__ + "static/about-d6e2e06929a8f125ccab5db87bb8609e.mp4";